import type { SVGProps } from 'react';

export const CameraOffIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.95993 22.0399C2.1546 22.2359 2.4106 22.3332 2.6666 22.3332C2.9226 22.3332 3.1786 22.2345 3.37326 22.0399L22.0413 3.37454C22.4319 2.98387 22.4319 2.35054 22.0413 1.95987C21.6506 1.5692 21.0173 1.5692 20.6266 1.95987L16.3558 6.23037C15.7997 4.92119 14.511 3.99988 12.9999 3.99988H4.99993C2.97727 3.99988 1.33327 5.64388 1.33327 7.66654V16.3332C1.33327 17.6663 2.05078 18.8283 3.11781 19.4674L1.95993 20.6252C1.56926 21.0159 1.56926 21.6492 1.95993 22.0399ZM7.99993 9.33321C7.99993 8.59721 7.4026 7.99988 6.6666 7.99988C5.9306 7.99988 5.33327 8.59721 5.33327 9.33321C5.33327 10.0692 5.9306 10.6665 6.6666 10.6665C7.4026 10.6665 7.99993 10.0692 7.99993 9.33321ZM12.9999 19.9999H8.24261L16.6666 11.5759V16.3332C16.6666 18.3559 15.0226 19.9999 12.9999 19.9999ZM23.1813 6.69187C22.6906 6.40254 22.1079 6.38921 21.6039 6.63854L18.6666 9.57587V15.7585L21.5293 17.3332C21.7826 17.4732 22.0586 17.5425 22.3346 17.5425C22.6266 17.5425 22.9186 17.4639 23.1813 17.3092C23.6946 17.0052 23.9999 16.4692 23.9999 15.8732V8.12787C23.9999 7.53187 23.6946 6.99587 23.1813 6.69187Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
